import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=56d9b9be&scoped=true&"
import script from "./video-player.vue?vue&type=script&lang=ts&"
export * from "./video-player.vue?vue&type=script&lang=ts&"
import style0 from "./video-player.vue?vue&type=style&index=0&id=56d9b9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9b9be",
  null
  
)

export default component.exports